import React, { createContext, useState, useContext } from 'react';
import {
    ENDPOINT_PRODUCTS_ENG,
    ENDPOINT_NEWS_ENG,
    ENDPOINT_CONSULT_ENG,
    ENDPOINT_PRIVACY_ENG,
    LANG_ENG,
    LANG_SV,
} from '../strings';

const LanguageContext = createContext();

// Every English route must be listed here, otherwise the page prerenders in Swedish
// and self-canonicalises to its Swedish twin — which silently drops it from the
// sitemap (generate-sitemap.js dedupes on canonical) and kills its hreflang pair.
const ENGLISH_ENDPOINTS = [
    ENDPOINT_PRODUCTS_ENG,
    ENDPOINT_NEWS_ENG,
    ENDPOINT_CONSULT_ENG,
    ENDPOINT_PRIVACY_ENG,
];

// Derive language from the URL so prerendering (react-snap, empty localStorage)
// and shared deep links resolve to the correct language instead of always 'sv'.
function detectLanguageFromPath() {
    if (typeof window === 'undefined') return null;
    const path = window.location.pathname;
    const isEnglish = ENGLISH_ENDPOINTS.some(
        (endpoint) => path === endpoint || path.startsWith(`${endpoint}/`)
    );
    return isEnglish ? LANG_ENG : null;
}

export function LanguageProvider({ children }) {
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return detectLanguageFromPath() || localStorage.getItem('language') || LANG_SV;
    });

    const changeLanguage = (lang) => {
        setCurrentLanguage(lang);
        localStorage.setItem('language', lang);
    };

    return (
        <LanguageContext.Provider value={{ currentLanguage, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
}

// Custom hook to use the language context
export function useLanguage() {
    const context = useContext(LanguageContext);
    if (context === undefined) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
}